import { useEffect, useRef } from 'react';
import { AtlasMark, Icon } from '../icons';
import { formatTimeAgo } from '../utils';
import { LiveState } from './Status';

export function HostScope({ hosts, host, onHost, compact = false }) {
  if (compact) {
    return (
      <label className="host-select">
        <select value={host} onChange={(event) => onHost(event.target.value)} aria-label="Memory host">
          {hosts.map((item) => <option key={item.id} value={item.id}>{item.label}</option>)}
        </select>
        <Icon name="chevron" size={14}/>
      </label>
    );
  }
  return (
    <div className="host-scope" aria-label="Memory host">
      {hosts.map((item) => <button key={item.id} className={host === item.id ? 'is-active' : ''} onClick={() => onHost(item.id)}><span className={`host-dot host-dot--${item.state}`}/>{item.label}</button>)}
    </div>
  );
}

export function Topbar({ search, onSearch, connected, host, hosts, onHost, data }) {
  const inputRef = useRef(null);
  useEffect(() => {
    const onKey = (event) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') { event.preventDefault(); inputRef.current?.focus(); }
      if (event.key === 'Escape' && document.activeElement === inputRef.current) { inputRef.current.blur(); onSearch(''); }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onSearch]);
  return (
    <header className="topbar topbar--refined">
      <div className="mobile-topline"><span className="mobile-brand"><AtlasMark size={30}/><span>Codex Memory Atlas</span></span><HostScope hosts={hosts} host={host} onHost={onHost} compact /></div>
      <label className="search-field search-field--quiet">
        <Icon name="search" size={19}/><input ref={inputRef} type="search" value={search} onChange={(event) => onSearch(event.target.value)} placeholder="Search memory" aria-label="Search every memory"/>
        {search ? <button type="button" onClick={() => onSearch('')} aria-label="Clear search"><Icon name="close" size={15}/></button> : <kbd>⌘K</kbd>}
      </label>
      <div className="topbar__scope-state"><div className="topbar__host-tabs"><HostScope hosts={hosts} host={host} onHost={onHost}/></div><div className="topbar__host-compact"><HostScope hosts={hosts} host={host} onHost={onHost} compact/></div><div className="topbar__state"><LiveState connected={connected} compact={host !== 'local'} readOnly={Boolean(data?.host?.readOnly)}/><small title="Most recent memory timestamp">Latest memory {formatTimeAgo(data?.host?.sourceUpdatedAt || data?.updatedAt)}</small></div></div>
    </header>
  );
}
